/*
 * View for Tableau ad-hoc workbooks
 */

define([
  "marionette",
  "modules/reportSplit/groups/adHocWorkbooks/template/adHocWorkbooksTemplate.html",
], function (Marionette, AdHocWorkbooksTemplate) {
  var AdHocWorkbooksView = {};

  AdHocWorkbooksView.adHocWorkbooksLayout = Marionette.Layout.extend({
    template: AdHocWorkbooksTemplate,
    regions: {
      list: "#workbookList",
    },
    triggers: {
      "click #addWorkbook": "add:workbook",
    },
  });

  return AdHocWorkbooksView;
});
